<div #discussionComponent class="card h-100">
  <div class="card-header">
    <div>
      <h3 (click)="checkViewToReturnTo($event)" class="cursor-pointer">
        <sb-icon *ngIf="discussionService.selectedGroup" class="mr-2 icon-in-btn" icon="chevronLeft"></sb-icon>
        <div class="ml-2">
          <span *ngIf="discussionService.selectedGroup"
                [innerHTML]="discussionService.selectedGroup.element.name | truncate: 34"></span>
          <span *ngIf="!discussionService.selectedGroup"
                [innerHTML]="translate.instant('lang.globals.overview')"></span>
        </div>
      </h3>
    </div>
    <div class="header-more">
      <button (click)="discussionService.toggleShowRibbon($event)"
              [ngClass]="{'btn-hover-primary--active' : discussionService.showRibbon}"
              class="btn mr-2 btn-hover-primary">
        <sb-icon *ngIf="discussionService.showRibbon" class="cursor-pointer" icon="discussionsFilled"></sb-icon>
        <sb-icon *ngIf="!discussionService.showRibbon" class="cursor-pointer" icon="discussionsNone"></sb-icon>
      </button>
      <button (click)="discussionService.addNewTopic()" *ngIf="discussionService.selectedGroup"
              class="btn mr-2 btn-hover-primary">
        <sb-icon class="cursor-pointer" icon="plus"></sb-icon>
      </button>
      <button (click)="toggleSideBar()" class="btn btn-hover-primary">
        <sb-icon class="icon-in-btn" icon="cancel"></sb-icon>
      </button>
    </div>
  </div>

  <div class="card-body" style="padding-bottom: 100px;">
    <ng-scrollbar [track]="'vertical'" style="height: 100%">

      <!-- Topic list -->
      <div *ngIf="discussionService.loading">
        <h3>{{'lang.globals.loading' | translate}}</h3>
      </div>
      <div *ngIf="!discussionService.selectedGroup && !discussionService.newTopic && !discussionService.selectedTopic">
        <div *ngFor="let group of discussionService.groupedDiscussionList">
          <ng-container *ngIf="group?.topics?.length > 0">
            <h6 class="mt-3 mb-2">{{group.element.name}}</h6>
            <div (click)="selectTopic(group.element, item, $event)" *ngFor="let item of group.topics">
              <sb-comp-discussion-topic [inChat]="false" [post]="item" classes="my-2 hasHover"></sb-comp-discussion-topic>
            </div>
          </ng-container>
        </div>
        <div *ngIf="!checkForDiscussions() && !discussionService.loading">
          {{'lang.discussion.noDiscussion' | translate}}
        </div>
      </div>
      <div *ngIf="discussionService.selectedGroup && !discussionService.newTopic && !discussionService.selectedTopic">
        <div (click)="selectTopic(discussionService.selectedGroup, item, $event)"
             *ngFor="let item of discussionService.selectedGroup.topics">
          <sb-comp-discussion-topic [inChat]="false" [post]="item" classes="my-2"></sb-comp-discussion-topic>
        </div>
      </div>
      <!-- No discussions for specific group-->
      <div
        *ngIf="(discussionService.selectedGroup && discussionService.selectedGroup.topics.length === 0 && !discussionService.newTopic && !discussionService.selectedTopic)">
        {{'lang.discussion.noDiscussion' | translate}}
      </div>
      <!-- new Topic -->
      <sb-topic-edit (topicEmitter)="updateTopicAndReturnToView($event)"
                     *ngIf="discussionService.newTopic && discussionService.selectedGroup "></sb-topic-edit>
      <!-- Discussion chat-->
      <div *ngIf="discussionService.selectedTopic && !discussionService.newTopic">
        <sb-comp-discussion-topic (goBack)="closeTopic()" [inChat]="true"
                                  [post]="discussionService?.selectedTopic"
                                  classes="mb-0 topic-element"></sb-comp-discussion-topic>
        <sb-comp-discussion-main-post (deleteMainPost)="updateOverview()" (editMainPost)="updateTopic()"
                                      [currentUser]="currentUser"
                                      [mainPost]="discussionService?.selectedTopic"></sb-comp-discussion-main-post>
        <div *ngIf="discussionService.selectedTopic?.solution"
             class="mt-1 discussionSubtitleBg chatBox p-2">
          <h3 class="d-flex justify-content-center">Solution</h3>

          <sb-comment-component [currentUser]="currentUser" [post]="discussionService?.selectedTopic?.solution"
                                [solutionDisplay]="true" [theme]="theme"></sb-comment-component>

        </div>
        <div *ngFor="let item of discussionService?.selectedTopic?.posts" class="mt-1">
          <sb-comment-component (newUserComment)="updateTopic()" [currentUser]="currentUser"
                                [isSelf]="currentUser?.name === item?.createdBy?.name" [level]="0" [post]="item"
                                [theme]="theme">
            <sb-comment-component (newUserComment)="updateTopic()" *ngFor="let levelOneChild of item.answers"
                                  [currentUser]="currentUser"
                                  [isSelf]="currentUser?.name === levelOneChild?.createdBy?.name" [level]="1"
                                  [post]="levelOneChild"
                                  [theme]="theme">
              <sb-comment-component (newUserComment)="updateTopic()" *ngFor="let levelTwoChild of levelOneChild.answers"
                                    [currentUser]="currentUser"
                                    [isSelf]="currentUser?.name === levelTwoChild?.createdBy?.name" [level]="2"
                                    [post]="levelTwoChild"
                                    [theme]="theme">
                <sb-comment-component (newUserComment)="updateTopic()"
                                      *ngFor="let levelThreeChild of levelTwoChild.answers"
                                      [currentUser]="currentUser"
                                      [isSelf]="currentUser?.name === levelThreeChild?.createdBy?.name" [level]="3"
                                      [post]="levelThreeChild"
                                      [theme]="theme">
                  <sb-comment-component (newUserComment)="updateTopic()"
                                        *ngFor="let levelFourChild of getTraversedArray(levelThreeChild.answers)"
                                        [currentUser]="currentUser"
                                        [isSelf]="currentUser?.name === levelFourChild?.createdBy?.name" [level]="4"
                                        [post]="levelFourChild"
                                        [theme]="theme">
                  </sb-comment-component>
                </sb-comment-component>
              </sb-comment-component>
            </sb-comment-component>
          </sb-comment-component>

        </div>
        <div *ngIf="!replyClicked" class="p-2">
          <div (click)="toggleReplyField($event)" class="p-2 selfMargin chatBox discussionSubtitleBg">
            <div class="ml-4">
              {{'lang.discussion.addReply'| translate}}
            </div>
          </div>
        </div>
        <div>
          <div *ngIf="replyClicked" class="p-2">
            <label class="form-label d-flex justify-content-end" for="Reply">
              <div class="d-flex align-items-center">
                <p [innerHTML]="currentUser.name| truncate: 35" class="font-weight-bold m-1"></p>
                <!-- [innerHTML]=element.name | truncate : 23"></p>-->
                <!--<p [innerHTML]="getCurrentTime()?.toString()| date: 'dd.MM.yy HH:mm'" class="m-1"></p> -->
              </div>
              <div>
                <sb-avatar [users]="[currentUser]"></sb-avatar>
              </div>
            </label>
            <div class="position-relative">
              <button (click)="toggleMentionUsers($event)" class="btn btn-default">
                <sb-icon [icon]="'at'"></sb-icon>
              </button>
              <div *ngIf="mentions && mentions.length > 0" class="d-flex mt-2">
                <div *ngFor="let user of mentions">
                  <div (click)="removeUser(user)" *ngIf="mentions.length <= 5" class="d-flex align-items-center">
                    <sb-avatar [users]="[user]"></sb-avatar>
                    <span class="font-weight-bold mx-2">
                   {{user.firstname}} {{user.lastname}}
                </span>
                  </div>
                  <div (click)="removeUser(user)" *ngIf="mentions.length > 5">
                    <sb-avatar [ngbTooltip]="user.firstname + ' ' + user.lastname" [users]="[user]"></sb-avatar>
                  </div>
                </div>
              </div>
              <textarea #textareaReply (ngModelChange)="lookForMentions($event)"
                        [(ngModel)]="reply"
                        class="form-control chatBox mt-2"
                        id="Reply" name="ReplyField"
                        rows="4"
                        sbAutofocus
                        type="text"></textarea>
              <sb-comp-discussion-mentions (cancelEmitter)="handleCancel($event)"
                                           (userSelect)="selectUser($event)"
                                           *ngIf="mentionUsers"
                                           [(searchStatus)]="searchStatus"
                                           [permissionName]="permissionService.Permission.campaign_show"
                                           [searchStr]="mentionSearchStr"></sb-comp-discussion-mentions>
            </div>
            <div class="d-flex justify-content-end mt-2">
              <button (click)="sendReply($event)"
                      class="btn btn-hover-primary mr-2">{{'lang.globals.reply' | translate}}
              </button>
              <button (click)="toggleReplyField($event)"
                      class="btn btn-danger">{{'lang.globals.close' | translate}}</button>
            </div>
          </div>

        </div>
      </div>
    </ng-scrollbar>
  </div>
</div>

